import { BASE_URL } from "../../../shared/utils/variables";
import { getAuthHeaders } from "../../../shared/services/authentication";

const baseURL = BASE_URL;

export const fetchRubricas = async () => {
    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    try {
        const response = await fetch(`${baseURL}/rubricas`, options);
        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro ao buscar rubricas:', error);
        throw error;
    }
}

export const fetchRubricaService = async (id: string) => {
    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    try {
        const response = await fetch(`${baseURL}/rubrica/${id}`, options);
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Erro ao buscar rubrica:', error);
        throw error;
    }
}

export const fetchRubricasGrouped = async () => {
    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    try {
        const response = await fetch(`${baseURL}/rubricas-grouped`, options);
        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro ao buscar rubricas agrupadas:', error);
        throw error;
    }
}